import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

import { CalendarService } from '@frontend/sports/calendar/feature';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { UrlHelperService } from '@frontend/sports/navigation/core/feature/url-helper';

import { BreadcrumbModel } from '../breadcrumbs/breadcrumb.models';
import { IBreadcrumbsResolve } from '../breadcrumbs/breadcrumbs.resolver';

@Injectable({ providedIn: 'root' })
export class CalendarBreadcrumbsResolver implements IBreadcrumbsResolve {
    private sitecore = inject(Sitecore);
    private urlHelper = inject(UrlHelperService);
    private calendar = inject(CalendarService);
    private router = inject(Router);

    resolve(): BreadcrumbModel[] {
        const crumbs: BreadcrumbModel[] = [];
        const append = (icon: string, title: string, url: string) => crumbs.push({ icon, title, url });

        const contextUri = this.router.url.split('/').pop();
        const context = contextUri ? decodeURI(contextUri) : undefined;

        const interval = this.calendar.getInterval(context);

        if (interval) {
            append('sports-calendar', this.sitecore.globalMessages.Calendar, this.urlHelper.getCalendarUrl());
            append('sports-soon', interval.title, this.urlHelper.getUrl(`/${interval.name}`));
        }

        return crumbs;
    }
}
